export const KEYS = {
    ENCRYPTED_PAYLOAD: "dkerakt",
    AES_KEY_HEX: "kwmowe",
    IV_HEX: "vwjpwb",
    MAC: "vkritkpw",
    CONVERSATION_ID: "pofwtu",
    PRELOGIN_SSID: "rdisl",
    POSTLOGIN_SSID: "odisl",
    ARCHIVEMESSAGE_TOKEN: "arctkn",
    ARCHIVECHAT_ID: "arccid",
};

// Hardcoded greeting (not read from index.html)
export const GREETING_MSG_PRE =
    "<p>Hello, I’m your virtual assistant from Taxlab.</p>";
export const IDLE_MSG = "Is there anything else that I can help you with?";
export const ERROR_MSG = "I'm unable to proceed with the question. Please try again";
export const NOT_FOUND_MENU_MSG =
    "I'm sorry, I can't find what you're looking for right now. Please try again.";

export const INPUT_PLACEHOLDER_MSG = "Type your message here";
export const CHARACTER_LIMIT = 200;
export const QUERY_PARAMS = window.location.search.substring(1);
export const INTERNAL_PARAM = "m=int";
export const QUEUE_RETRY_COUNT = 30;

// Hardcoded user config (not read from index.html)
export const USER_DATA = {
    chatSessionID: "",
    isLoginInFlag: "false",
    SourceChat: "WEB",
};

export const CHAT_SESSION_ID = USER_DATA.chatSessionID;
export const SOURCE_CHAT = USER_DATA.SourceChat;
export const IS_LOGIN =
    USER_DATA.isLoginInFlag.toString().toLowerCase() === "true";

export const ALLOWED_HOSTNAME = [
    "localhost",
    "taxlab.ai"
];

export const CLIENT_SECRET = "3234";
export const FIVE_MIN = 5 * 60 * 1000;
